
import request from '@/config'
import { BillAuditDto } from './bill.dto';

/* 获取收款/付款单明细 */
export const GetBillDetailApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/getbilldetail', data: { id: rowId } })
}

/* 获取收款/付款单明细(OA工作流ID) */
export const GetBillDetailByWorkIdApi = (workId: number): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/getbilldetailbyworkid', data: { work_id: workId } })
}

/* 付款审批：通过 */
export const BillAuditAgreeApi = (auditData: BillAuditDto): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/billauditagree', data: auditData })
}


/* 付款审批：拒绝 */
export const BillAuditRejectApi = (auditData: BillAuditDto): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/billauditreject', data: auditData })
}

/* 付款审批：催办 */
export const BillAuditTourgeApi = (workId: string): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/audittourge', data: { id: workId } })
}


/* 付款审批：审批列表 */
export const BillWorkListApi = (billId: string): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/getworkitemlist', data: { id: billId } })
}

/* 付款审批：审批列表 */
export const BillWorkListApiByPlan = (PlanId: string): Promise<IResponse> => {
    return request.post({ url: '/api/contractbill/getworkitemlistplanid', data: { id: PlanId } })
}


